import {call, put, takeLatest} from 'redux-saga/effects';
import {SUCCESS_KEY} from 'constants/keys';
import {
  smartSearchRequest,
  smartSearchFailure,
  smartSearchSuccess,
  smartSearchRequestParams,
  smartSearchSuccessResponse,
} from 'redux/slices/dashboardSlice';
import {smartSearch as smartSearchAPI} from 'services/api';

/**
 * type for get employee request
 */

type SmartSearchRequestAction = {
  type: typeof smartSearchRequest.type;
  payload: smartSearchRequestParams;
};

type SmartSearchResponse = {
  status: string;
} & smartSearchSuccessResponse;

/**
 * smart search saga
 */
function* smartSearch(action: SmartSearchRequestAction): Generator {
  try {
    const response: SmartSearchResponse = yield call(
      smartSearchAPI,
      action.payload,
    );
    if (response.status === SUCCESS_KEY) {
      yield put(smartSearchSuccess(response));
    } else {
      yield put(smartSearchFailure(response.status_code));
    }
  } catch (error) {
    yield put(smartSearchFailure('E-10001'));
  }
}

export function* dashboardSaga() {
  yield takeLatest(smartSearchRequest.type, smartSearch);
}
